import React,{useState,useEffect} from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import {TextAreaInput1, TextInput} from '../../components/input';
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { toast } from 'react-hot-toast';
import SettingsMenu from '../staticscreens/SettingsMenu';
import GoBack from '../../components/back/GoBack';
import { CreatePersonalTrainingSubscriptionService, UpdatePersonalTrainingSubscriptionService } from '../../services/class_booking/personalTrainingSubscrriptionServices';

function PersonalTrainingSubscriptionCE() {

  const navigate = useNavigate()  
  const location = useLocation()
  const {state} = useLocation()

  const [data,setdata] = useState({
    amount:'',
    plan:'',
    description:'',
    sort:'',
    days_validity:''
  })

  useEffect(()=>{
    if(location?.pathname?.split('/')[location?.pathname?.split('/').length - 1] === 'edit'){
     setdata({...state})
    }
  },[])

  const [error,seterror] = useState({
    amount:'',
    plan:'',
    description:'',
    sort:'',
    days_validity:''
  })

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }


  async function submitdata(){
    if(!data.amount){
        seterror({...error,amount:'This Field is required*'})
    }else if(!data.plan){
        seterror({...error,plan:'This Field is required*'})
    }else if(!data.description){
        seterror({...error,description:'This Field is required*'})
    }else if(!data.sort){
        seterror({...error,sort:'This Field is required*'})
    }else if(!data.days_validity){
        seterror({...error,days_validity:'This Field is required*'})
    }else{
       
        let send_data = {...data}

      
        if(location.pathname.split('/')[location.pathname.split('/').length - 1] === 'create'){
            const response = await CreatePersonalTrainingSubscriptionService(send_data)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 201){
                toast.success("Subscription Created Successfully")
                resetform()
            }
        }else{
            const response = await UpdatePersonalTrainingSubscriptionService(send_data,state?._id)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 200){
                toast.success("Subscription Updated Successfully")
                resetform()
                navigate(-1)
            }
        }
        
    }
  }

  function resetform(){
    setdata({
        amount:'',
        plan:'',
        description:'',
        sort:'',
        days_validity:''
      })
    seterror({
        amount:'',
        plan:'',
        description:'',
        sort:'',
        days_validity:''
      })
  }


  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen md:min-h-screen md:overflow-hidden'>
        <div className='md:flex'> 
         <SettingsMenu />
          <div className='px-5 md:w-full'>

          
        <div className='md:flex md:w-full md:min-h-screen md:max-h-screen md:overflow-y-scroll mb-10'>
        <div className='w-full md:border-r md:w-64 md:pr-5 md:pt-5'>
        <GoBack />  

        <h6 className='font-[700] mb-1'>Create/Edit Personal Traning Subscription</h6>
          <h6 className='text-[11px] p-2  mb-2 bg-slate-100'>Use the below form to create or update a personal training subscription</h6>
        



        <TextInput 
         label={'Amount'}  
         variant="standard"
         name="amount"
         type="text"
         error={error.amount}
         value={data.amount}
         handlechange={handlechange}
         placeholder="Enter your Amount"
         />


        <div className="w-full mr-1"> 
        <TextInput 
         label={'Plan'}  
         variant="standard"
         name="plan"
         type="text"
         error={error.plan}
         value={data.plan}
         handlechange={handlechange}
         placeholder="Enter your plan"
         />
        </div> 


        <TextAreaInput1 
         label={'Description'}  
         variant="standard"
         name="description"
         type="text"
         error={error.description}
         value={data.description}
         handlechange={handlechange}
         placeholder=""
         />

        <div className="w-full mr-1"> 
        <TextInput 
         label={'Days Validity'}  
         variant="standard"
         name="days_validity"
         type="number"
         error={error.days_validity}
         value={data.days_validity }
         handlechange={handlechange}
         placeholder="Enter your days_validity"
         />
        </div> 

         <div className="w-full mr-1"> 
        <TextInput 
         label={'Sort'}  
         variant="standard"
         name="sort"
         type="text"
         error={error.sort}
         value={data.sort}
         handlechange={handlechange}
         placeholder="Enter your sort"
         />
        </div> 

    

         <div className='flex mt-4 pb-5'>
            <ButtonOutlinedAutoWidth btnName={'Back'} onClick={()=>{navigate(-1)}} />
            <div className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Save'} onClick={submitdata} />
            </div>
         </div>
        </div>
       
         </div>
         </div>
         </div>




    </div>
  )
}

export default PersonalTrainingSubscriptionCE